import { TableColumnsType } from "antd";
import React from "react";
import ReusableTable from "../../../../../../global components/Table/Table";
import NoData from "../../../../../../global components/Table/NoData/NoData";
import { PieChart } from "../../../../../../global components/Icons/PieChart";
import { PaginatedEmailsReportType } from "../../../../../../libs/Utils/Types/Reports";
import dayjs from "dayjs";
import Unauthorised from "../../../../../../global components/Unauthorised";
type ColumnsType = {
  serialNumber: number;
  key: number;
  date: string;
  emailSent: number;
  bounceRate: string;
  ctr: string;
  opens: string;
};
type PropType = {
  isLoading: boolean;
  dataSource: PaginatedEmailsReportType["data"];
  unauthorized: boolean | { title: string; message: string };
};
function EmailReportTable({ dataSource, isLoading, unauthorized }: PropType) {
  const columns: TableColumnsType<ColumnsType> = [
    {
      title: "S/N",
      dataIndex: "serialNumber",
      key: "serialNumber",
      render: (serialNumber: number) => <span>{serialNumber}</span>,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date: string) => <span>{date}</span>,
    },
    {
      title: "Email Sent",
      dataIndex: "emailSent",
      key: "emailSent",
      render: (emailSent: number) => <span>{emailSent}</span>,
    },
   
    {
      title: "Open rate",
      dataIndex: "opens",
      key: "opens",
      render: (opens: number) => <span>{opens}</span>,
    },
    {
      title: "CTR (Click-Through RATE)",
      dataIndex: "ctr",
      key: "ctr",
      render: (ctr: string) => <span>{ctr}</span>,
    },
    {
      title: "Bounce rate",
      dataIndex: "bounceRate",
      key: "bounceRate",
      render: (bounceRate: string) => <span>{bounceRate}</span>,
    },
  ];
  const data: ColumnsType[] =
    dataSource.map((item, index) => ({
      date: dayjs.utc(item.date).local().format("MMM DD, YYYY"),
      emailSent: item.totalSent,
      key: index + 1,
      opens: `${item.openRate}`,
      serialNumber: index + 1,
      ctr: item.deliveredRate,
      bounceRate: item.failedRate,
    })) ?? [];
  return (
    <ReusableTable
      columns={columns}
      dataSource={data}
      loading={isLoading}
      noDataComponent={
        unauthorized ? (
          typeof unauthorized === "boolean" ? (
            <Unauthorised />
          ) : (
            <Unauthorised error={unauthorized} />
          )
        ) : (
          <NoData
            Message="No email report found"
            subMessage=""
            icon={<PieChart height={32} width={32} />}
          />
        )
      }
    />
  );
}

export default EmailReportTable;
